<!--  -->
  <div class="body__options container-body-options"   [ngClass]="selectedOption === 'ZONE' ? 'show': 'hide'">
      <p *ngIf="selectedVehicle === null">Seleccione un equipo en la licencia.</p>
      <div class="row mb-4" *ngIf="selectedVehicle !== null">
          <div class="col-12 col-md-4 body__col" >
              <h5>Vehículo registrado</h5>
              <div class="d-flex">
                  <p>
                    {{selectedVehicle.equipmentName}}
                    <br>
                    {{selectedVehicle.equipmentBrand}}
                    -
                    {{selectedVehicle.equipmentModel}}
                  </p>
              </div>
          </div>
          <div class="col-12 col-md-4 body__col">
              <div class="form">
                  <label for="" class="label">Tipo de licencia</label>
                  <div class="d-flex">
                      <div class="mr-5">
                        <div class="form__check mb-2 global-no-pointer-events" *ngFor="let item of licenseTypes; index as i;">
                          <ng-container *ngFor="let control of [asFormGroup(asFormArray(newEquipmentForm.controls.licenseTypes).at(i))]">
                            <label
                              *ngIf="control.value.active"
                              for="opt2{{item.name}}{{item.id}}"
                            >
                              <div
                                class="fakebox point"
                              ></div>
                              {{ item.name }}
                            </label>
                          </ng-container>
                        </div>
                      </div>
                  </div>
              </div>
          </div>
          <div class="col-12 col-md-4">
              <div class="form">
                  <label for="" class="label">
                  Área de conducción
              </label>
                <div class="d-flex">
                  <div class="mr-5">
                      <div
                      *ngFor="let item of conductionZones | slice: 0 : round(conductionZones.length/2) ;index as i"
                      class="form__check mb-2"
                        [ngClass]="{'global-no-pointer-events': getCheckControls(item.id).disabled.value}"
                      >
                        <input
                          type="checkbox"
                          id="opt2{{item.name}}{{item.id}}"
                          [formControl]="getCheckControls(item.id).active"
                          [attr.disabled]="getCheckControls(item.id).disabled.value ? true : null"
                        >
                        <label for="opt2{{item.name}}{{item.id}}">
                        <div
                          class="fakebox"
                          [ngClass]="{
                            'dark-grey-bg': getCheckControls(item.id).disabled.value
                          }"
                        ></div>
                          {{ item.name }}
                        </label>
                      </div>
                  </div>
                  <div>
                      <div
                        *ngFor="let item of conductionZones | slice:  round(conductionZones.length/2) : conductionZones.length ;index as i"
                        class="form__check mb-2"
                        [ngClass]="{'global-no-pointer-events': getCheckControls(item.id).disabled.value}"
                      >
                        <input
                          type="checkbox"
                          id="opt2{{item.name}}{{item.id}}"
                          [formControl]="getCheckControls(item.id).active"
                          [attr.disabled]="getCheckControls(item.id).disabled.value ? true : null"
                        >
                        <label for="opt2{{item.name}}{{item.id}}">
                        <div
                          class="fakebox"
                          [ngClass]="{
                            'dark-grey-bg': getCheckControls(item.id).disabled.value
                          }"
                        ></div>
                          {{ item.name }}
                        </label>
                      </div>
                  </div>
                </div>
              </div>
          </div>
      </div>
      <button
        *ngIf="selectedVehicle !== null"
        [disabled]="newEquipmentForm.valid ? false : true"
        type="button"
        class="btn btn--primary ingresar"
        (click)="onAddNewEquipment()"
      >
        Registrar nuevas zonas
      </button>
  </div>
<!-- </div> -->
